import React from 'react';
import {usePromiseTracker} from "react-promise-tracker";
import { InputLoadingSkeleton } from '../DommusLoadingSkeleton/InputLoadingSkeleton';

export default function DommusLoadingInput({area, children}) {
	const {promiseInProgress} = usePromiseTracker({area: area});

	return (
		promiseInProgress ?
          <InputLoadingSkeleton/>
        : children
	);
}
